import { render, staticRenderFns } from "./not_found.vue?vue&type=template&id=6d52ca4b&scoped=true&"
import script from "./not_found.vue?vue&type=script&lang=js&"
export * from "./not_found.vue?vue&type=script&lang=js&"
import style0 from "./not_found.vue?vue&type=style&index=0&id=6d52ca4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52ca4b",
  null
  
)

export default component.exports